// extracted by mini-css-extract-plugin
export default {"navigation":"navbar_navigation__K-gFj","social-icons":"navbar_social-icons__AgAIH"};